export default __webpack_public_path__ + "static/media/resourcesIcon.52abc4b8.svg";